export var CommonSchemaIds;
(function (CommonSchemaIds) {
    CommonSchemaIds["VISIBLE"] = "visible";
    CommonSchemaIds["CHART_TYPE"] = "chart-type";
})(CommonSchemaIds || (CommonSchemaIds = {}));
